import React from 'react'
import { useLocation } from 'react-router-dom'
import { IInvoice } from '../api/Radom'
import PayInvoice from '../components/PayInvoice'
import { parsePreviewHash } from '../util/Preview'
import { previewInvoice } from '../util/PreviewData'

const InvoicePreview = (): React.ReactElement => {
  const location = useLocation()
  const invoiceData = parsePreviewHash<IInvoice>(location.hash) ?? previewInvoice

  return <PayInvoice
    previewData={invoiceData}
    hideTravelRuleFields={true}
  />
}

export default InvoicePreview
